var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { batch } from "react-redux";
import { Checkout } from "./Checkout";
import get from "lodash/get";
import pickBy from "lodash/pickBy";
import { CHECKOUT_CONTEXT_ENUM, patchForm, updateCustomerId, updateForm } from "../../store/actions";
import { getCustomerEntities } from "../../store/actions/response.actions";
import { useConfig } from "../../AppContext";
import { connect } from "../../store/connect";
import { getFirstTimespanId } from "../BookingForm/booking-form.helpers";
var adminCheckoutFactory = function () {
    var AdminCheckoutPage = function (_a) {
        var getCustomerEntities = _a.getCustomerEntities, customerData = _a.customerData, patchForm = _a.patchForm, updateForm = _a.updateForm, timespanId = _a.timespanId, customerId = _a.customerId, formName = _a.formName, hasCustomerData = _a.hasCustomerData, props = __rest(_a, ["getCustomerEntities", "customerData", "patchForm", "updateForm", "timespanId", "customerId", "formName", "hasCustomerData"]);
        var customerIdFromContext = useConfig("customerId")[0];
        var selectedCustomerId = customerIdFromContext || customerId || "";
        React.useEffect(function () {
            batch(function () {
                patchForm({ name: formName, form_data: {} }, "checkout");
                updateCustomerId(selectedCustomerId);
            });
        }, [selectedCustomerId, formName]);
        React.useEffect(function () {
            getCustomerEntities(pickBy({ customerId: selectedCustomerId, timespanId: timespanId }, Boolean));
        }, [selectedCustomerId, timespanId]);
        React.useEffect(function () {
            return function () { return updateForm({ name: formName, form: undefined }, "checkout"); };
        }, []);
        return (React.createElement(Checkout, __assign({ formName: formName, buttonsWithIcon: true, isOneSided: true, hidePriceBreakup: true, showParticipantSearchAndSelect: true, collapseValidParticipantsByDefault: true, customerId: customerIdFromContext || customerId }, props)));
    };
    var mapStateToProps = function (state, _a) {
        var name = _a.name;
        return {
            timespanId: getFirstTimespanId(state, name),
            customerId: get(state, "appReducer.customerId", '') || '',
            formName: get(state, "globalReducer.checkoutContext", CHECKOUT_CONTEXT_ENUM.CART)
        };
    };
    return connect(mapStateToProps, { getCustomerEntities: getCustomerEntities, patchForm: patchForm, updateForm: updateForm })(AdminCheckoutPage);
};
export var AdminCheckoutPage = adminCheckoutFactory();
